export default {
  styleOverrides: {
    rectangular: {
      borderRadius: 3,
    },
  },
};
